'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint-disable react/no-array-index-key */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _generic = require('../../helpers/generic');

require('./EditableCell.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _antd.Select.Option;

var isNotificationDisplayed = false;

var EditableCell = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EditableCell, _Component);

  function EditableCell() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditableCell.__proto__ || (0, _getPrototypeOf2.default)(EditableCell)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fileList: []
    }, _this.handleChange = function (value) {
      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    }, _this.buildInputField = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          validators = _this$props.validators,
          placeholder = _this$props.placeholder;

      var characterCountValidator = validators.find(function (validator) {
        return validator.type === 'CHARACTER_COUNT_VALIDATOR';
      });

      var suffix = null;
      var characterLimit = null;
      var handleInputChange = function handleInputChange(value) {
        return _this.handleChange(value);
      };
      var characterCountClassName = '';

      if (characterCountValidator) {
        characterLimit = parseInt(characterCountValidator.args[0], 10);
        suffix = value.length + '/' + characterLimit;
        characterCountClassName = value.length >= characterLimit ? 'has-warning' : '';
      }

      return _react2.default.createElement(_antd.Input, {
        value: value || '',
        onChange: function onChange(e) {
          return handleInputChange(e.target.value);
        },
        suffix: suffix,
        style: { width: '100%' },
        placeholder: 'Enter ' + placeholder,
        className: 'EditableCell-input-box ' + characterCountClassName
      });
    }, _this.buildColourSelectField = function () {
      var _this$props2 = _this.props,
          validators = _this$props2.validators,
          value = _this$props2.value,
          placeholder = _this$props2.placeholder;

      var options = validators[0].args.map(function (item, index) {
        return _react2.default.createElement(
          Option,
          { key: index, value: item },
          _react2.default.createElement('span', {
            className: 'EditableCell-colour-box',
            style: { backgroundColor: '#' + item }
          }),
          item
        );
      });
      return _react2.default.createElement(
        _antd.Select,
        {
          value: value === '' ? undefined : value,
          placeholder: 'Select ' + placeholder,
          style: { width: '100%' },
          onChange: _this.handleChange
        },
        options
      );
    }, _this.buildMediaSelectField = function () {
      var _this$props3 = _this.props,
          validators = _this$props3.validators,
          contentType = _this$props3.contentType,
          value = _this$props3.value,
          placeholder = _this$props3.placeholder,
          enableUserMedia = _this$props3.enableUserMedia;


      var handleMediaChange = function handleMediaChange(_ref2) {
        var fileList = _ref2.fileList;

        if (!isNotificationDisplayed) {
          _antd.message.loading('Uploading content...');
          isNotificationDisplayed = true;
          setTimeout(function () {
            isNotificationDisplayed = false;
          }, 2000);
        }
        _this.setState({
          fileList: fileList
        }, function () {
          if (_this.state.fileList.every(function (item) {
            return item.status === "done";
          })) {
            _this.props.addCustomMediaAsset(_this.state.fileList);
            _this.setState({
              fileList: []
            });
          }
        });
      };

      var options = validators[0].args.map(function (item, index) {
        return _react2.default.createElement(
          Option,
          { key: index, value: item },
          contentType === 'IMAGE' && _react2.default.createElement(
            _antd.Tooltip,
            { key: index, placement: 'topRight', title: _react2.default.createElement('img', { src: item, style: { maxHeight: 300, maxWidth: 200 }, alt: 'Media ' + index }) },
            _react2.default.createElement('img', {
              className: 'EditableCell-image-box',
              src: item,
              alt: 'Media ' + index
            })
          ),
          (0, _generic.getImageNameFromURL)(item)
        );
      });

      var selectStyleWidth = enableUserMedia ? { width: '70%' } : { width: '100%' };
      var selectClassName = enableUserMedia ? 'select-media-button' : '';

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _antd.Select,
          {
            className: selectClassName,
            value: value === '' ? undefined : value,
            placeholder: 'Select ' + placeholder,
            style: selectStyleWidth,
            onChange: _this.handleChange
          },
          options
        ),
        enableUserMedia && _react2.default.createElement(
          _antd.Upload,
          {
            accept: (0, _generic.determineAcceptedAttributes)(contentType),
            action: _this.props.mediaActionUrl,
            customRequest: function customRequest(option) {
              return (0, _generic.upload)(option, _this.props.WSSEToken);
            },
            name: 'mediaFiles',
            fileList: _this.state.fileList,
            onChange: handleMediaChange,
            multiple: true,
            showUploadList: false
          },
          _react2.default.createElement(
            _antd.Button,
            { className: 'add-media-button' },
            _react2.default.createElement(_antd.Icon, { type: 'upload' })
          )
        )
      );
    }, _this.buildFields = function () {
      var contentType = _this.props.contentType;

      switch (contentType) {
        case 'COLOR':
          return _this.buildColourSelectField();
        // TODO: Video & Image should both be extracted out into their own methods
        case 'VIDEO':
        case 'IMAGE':
          return _this.buildMediaSelectField();
        case 'TEXT':
          return _this.buildInputField();
        default:
          return 'Error, Unknown Field';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditableCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.enableUserMedia === true) return true;else if (this.props.value === nextProps.value) return false;
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'EditableCell__Component' },
        this.buildFields()
      );
    }
  }]);
  return EditableCell;
}(_react.Component), _class.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  contentType: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  validators: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  WSSEToken: _propTypes2.default.string,
  mediaActionUrl: _propTypes2.default.string,
  addCustomMediaAsset: _propTypes2.default.func.isRequired,
  enableUserMedia: _propTypes2.default.bool
}, _class.defaultProps = {
  value: '',
  WSSEToken: '',
  mediaActionUrl: '',
  enableUserMedia: true
}, _temp2);
exports.default = EditableCell;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/EditableCell/index.js
// module id = 3889
// module chunks = 5 6 7 8